import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid'

export const UserDB = createSlice({
    name: 'user',
    initialState: {
        requestId: uuidv4(),
        name: '',
        code: '',
        email: '',
        phone: '',
        loading: false,
        create: {
            firstName: '',
            lastName: '',
            phone_number: '',
            phone: '',
            password: 'tirefax',
            orgId: '',
            role: '',
            smId: '',
            status: true
        }
    },
    reducers: {
        setLoading: (state, action) => {
            return {
                ...state,
                loading: action.payload
            }
        },

        resetUser: (state, action) => {
            return {
                ...state,
                create: {
                    firstName: '',
                    lastName: '',
                    phone_number: '',
                    phone: '',
                    password: 'tirefax',
                    orgId: '',
                    role: '',
                    smId: '',
                    status: true
                }
            }
        },

        resetRequestId: (state, action) => {
            return {
                ...state,
                requestId: uuidv4()
            }
        },

        userCreate: (state, action) => {
            var cc = {
                ...state.create,
                ...action.payload
            }
            return {
                ...state,
                create: cc
            }
        }
    }
})

export const { userCreate, setLoading, resetUser, resetRequestId } = UserDB.actions

export default UserDB.reducer